function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cdb072;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Jarden Logo HORZ GOLD RGB");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M76,93.64a2.14,2.14,0,0,0-3.65.51L66,109.56a2.1,2.1,0,0,0,1.18,2.75l.29.12a2.26,2.26,0,0,0,.8.15,2.15,2.15,0,0,0,2-1.31L74.86,100a.15.15,0,0,1,.14-.1.17.17,0,0,1,.17.06l7.59,9.58a2.15,2.15,0,0,0,3,.36l.25-.19a2.09,2.09,0,0,0,.37-3Z",
  transform: "translate(-44.85 -58.02)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M69.87,77a2.11,2.11,0,0,0,1.66.8,1.62,1.62,0,0,0,.31,0,2.12,2.12,0,0,0,1.68-1.29L79.84,61a2.1,2.1,0,0,0-1.18-2.75l-.3-.11a2.14,2.14,0,0,0-2.77,1.16L71,70.6a.17.17,0,0,1-.14.1.16.16,0,0,1-.17-.06l-7.6-9.57a2.15,2.15,0,0,0-3-.37l-.26.2a2,2,0,0,0-.8,1.41,2.06,2.06,0,0,0,.44,1.55Z",
  transform: "translate(-44.85 -58.02)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M79,80.59a2.11,2.11,0,0,0,1.68.83l.31,0,16.72-2.31a2.14,2.14,0,0,0,1.42-.83,2.1,2.1,0,0,0,.4-1.55l-.05-.31a2.11,2.11,0,0,0-2.4-1.79L84.87,76.28a.15.15,0,0,1-.17-.06.14.14,0,0,1,0-.16L89.3,64.81a2.09,2.09,0,0,0-1.18-2.75l-.29-.12a2.15,2.15,0,0,0-2.77,1.16L78.72,78.52A2.07,2.07,0,0,0,79,80.59",
  transform: "translate(-44.85 -58.02)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M66.81,90a2.12,2.12,0,0,0-2-.81L48.1,91.52a2.15,2.15,0,0,0-1.41.83,2.06,2.06,0,0,0-.4,1.55l0,.32A2.14,2.14,0,0,0,48.74,96L61,94.31a.2.2,0,0,1,.17.07.17.17,0,0,1,0,.16L56.52,105.8a2.09,2.09,0,0,0,0,1.61,2,2,0,0,0,1.16,1.13l.3.12a2,2,0,0,0,.79.16,2.14,2.14,0,0,0,2-1.32L67.1,92.08A2,2,0,0,0,66.81,90",
  transform: "translate(-44.85 -58.02)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M101,86.65l0-.31a2.12,2.12,0,0,0-2.4-1.79L81.79,86.86a2.1,2.1,0,0,0-1.39,3.38l10.4,13.11a2.17,2.17,0,0,0,3,.36l.25-.19a2.11,2.11,0,0,0,.81-1.41,2.14,2.14,0,0,0-.44-1.56L86.81,91a.13.13,0,0,1,0-.15.15.15,0,0,1,.14-.11L99.14,89a2.14,2.14,0,0,0,1.42-.83,2.08,2.08,0,0,0,.4-1.55",
  transform: "translate(-44.85 -58.02)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M47.32,86.05l16.73-2.31a2.1,2.1,0,0,0,1.68-1.31,2.06,2.06,0,0,0-.3-2.08L55,67.25a2.14,2.14,0,0,0-3-.35l-.25.19a2.08,2.08,0,0,0-.37,3L59,79.62h0a.12.12,0,0,1,0,.15.15.15,0,0,1-.14.11L46.68,81.57a2.09,2.09,0,0,0-1.41.83,2.06,2.06,0,0,0-.4,1.55l0,.31A2.14,2.14,0,0,0,47,86.08a1.53,1.53,0,0,0,.3,0",
  transform: "translate(-44.85 -58.02)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M147.57,103.83a16.08,16.08,0,0,1-11.84,4.59,16.39,16.39,0,0,1-12-4.62,15.11,15.11,0,0,1-4.23-7.39,3.77,3.77,0,0,1,3.6-4.54,3.87,3.87,0,0,1,3.91,2.89,8.68,8.68,0,0,0,8.68,6.38,8.33,8.33,0,0,0,6.34-2.64,9.52,9.52,0,0,0,2.49-6.8V65.1a3.77,3.77,0,0,1,3.8-3.74h0a3.77,3.77,0,0,1,3.8,3.74v27a15.91,15.91,0,0,1-4.61,11.77",
  transform: "translate(-44.85 -58.02)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M216.24,69.77V83a.86.86,0,0,0,.87.85h9.24a8.71,8.71,0,0,0,6.09-2.08,7.38,7.38,0,0,0,0-10.71,8.66,8.66,0,0,0-6.07-2.09h-9.24a.86.86,0,0,0-.87.85m17.9,36.39-8.75-14.85a.85.85,0,0,0-.75-.43h-7.53a.86.86,0,0,0-.87.85v12.6a3.69,3.69,0,0,1-3.72,3.66h-.28a3.69,3.69,0,0,1-3.72-3.66V63.5a1.72,1.72,0,0,1,1.73-1.7h16.52a16,16,0,0,1,11.29,4.12A14.46,14.46,0,0,1,240,84.65,14.27,14.27,0,0,1,233,89.82l7.54,12.65a3.67,3.67,0,0,1-3.21,5.52,3.75,3.75,0,0,1-3.22-1.83",
  transform: "translate(-44.85 -58.02)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M267.83,100.93a15.48,15.48,0,0,0,16.13-16,15.58,15.58,0,0,0-4.52-11.5,15.75,15.75,0,0,0-11.61-4.51h-7.74a.86.86,0,0,0-.87.85v30.35a.86.86,0,0,0,.87.85Zm.23-39.13a25.91,25.91,0,0,1,9.54,1.74,22.39,22.39,0,0,1,7.55,4.78,21.86,21.86,0,0,1,4.91,7.34,23.87,23.87,0,0,1,1.78,9.23,23.36,23.36,0,0,1-3,11.89,21.62,21.62,0,0,1-8.5,8.25,25.18,25.18,0,0,1-12.23,3H253.23a1.72,1.72,0,0,1-1.73-1.7V63.5a1.72,1.72,0,0,1,1.73-1.7Z",
  transform: "translate(-44.85 -58.02)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M308,100.84h15.88a3.48,3.48,0,0,1,3.51,3.45v.24a3.48,3.48,0,0,1-3.51,3.46H301.13a1.72,1.72,0,0,1-1.73-1.7V63.5a1.72,1.72,0,0,1,1.73-1.7h22a3.48,3.48,0,0,1,3.51,3.46v.2a3.49,3.49,0,0,1-3.51,3.46H308a.85.85,0,0,0-.86.85V80.11A.85.85,0,0,0,308,81h13.42a3.49,3.49,0,0,1,3.52,3.46v0a3.49,3.49,0,0,1-3.52,3.46H308a.85.85,0,0,0-.86.85V100a.85.85,0,0,0,.86.85",
  transform: "translate(-44.85 -58.02)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M369.53,61.8h.05a3.72,3.72,0,0,1,3.74,3.68V103.8a4.23,4.23,0,0,1-4.26,4.19h0a4.26,4.26,0,0,1-3.44-1.73L344.06,77.12a.86.86,0,0,0-1.56.5v26.69a3.72,3.72,0,0,1-3.74,3.68h-.08a3.72,3.72,0,0,1-3.74-3.68v-38a4.57,4.57,0,0,1,4.6-4.53h0a4.62,4.62,0,0,1,3.73,1.87l20.94,28.44a.86.86,0,0,0,1.56-.5V65.48a3.72,3.72,0,0,1,3.74-3.68",
  transform: "translate(-44.85 -58.02)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M199.93,102.84,184.07,65.08a5.43,5.43,0,0,0-10,0l-15.4,37.75a3.73,3.73,0,0,0,3.51,5.11,3.79,3.79,0,0,0,3.52-2.37l12.12-30.57a1.45,1.45,0,0,1,2.68,0l6.35,15.84h-7.63a3.55,3.55,0,1,0,0,7.09H189.7l3.07,7.66a3.78,3.78,0,0,0,3.52,2.36h.15a3.73,3.73,0,0,0,3.49-5.15",
  transform: "translate(-44.85 -58.02)"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 328.47 54.56",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.75175bb3.svg";
export { ForwardRef as ReactComponent };